import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'components'
import { useNavigate } from 'react-router-dom';
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { selectedOrgsState } from '../states'
import { useRecoilValue } from 'recoil'
import { transmitRequestInfo } from './TermsInformations'

const TransmitRequest1 = () => {

	const App = useApp()
	const navigate = useNavigate()
	const mounted = useRef(false)
	const selectedOrgs = useRecoilValue(selectedOrgsState)
	const [industries, setIndustries] = useState([])
	const [buttonText, setButtonText] = useState("아래로 내려보기")
	const [atBottom, setAtBottom] = useState(false)
	const core = useRef()

	const onNext = () => {
		if (atBottom) {
			navigate("/data/transmitRequest2")
		} else {
			const scrollTop = core.current.scrollTop
			const pageHeight = document.body.scrollHeight
			core.current.scrollTo(0, (scrollTop + pageHeight) * 0.8)
		}
	}

	const bindScroll = () => {
		if (core.current.clientHeight >= core.current.scrollHeight - 30) {
			setAtBottom(true)
		}
		core.current.addEventListener("scroll", e => {
			const clientHeight = core.current.clientHeight
			const scrollHeight = core.current.scrollHeight
			const scrollTop = core.current.scrollTop
			if (!mounted.current ) return
			if (clientHeight + scrollTop >= scrollHeight - 30) {
				setAtBottom(true)
			} else {
				setAtBottom(false)
			}
		})
	}

	useEffect(() => {
		if (atBottom) {
			setButtonText("동의하기")
		} else {
			setButtonText("아래로 내려보기")
		}
	}, [atBottom])

	useEffect(() => {
		if (selectedOrgs) {
			const newList = []
			selectedOrgs.forEach(org => {
				if (!newList.some(industry => industry === org.indstCd)) newList.push(org.indstCd)
			})
			setIndustries(newList)
		}
	}, [selectedOrgs])

	useEffect(() => {
		console.log({industries})
	}, [industries])

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		core.current = document.querySelector(".core")
		mounted.current && bindScroll()

		console.log({selectedOrgs})


		return () => mounted.current = false
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles["count-group"]}>
					<p>전송요구 및 정보 제공 동의</p>
					<div><span>3</span>/3</div>
				</div>
				<div className={`${styles["terms-area"]} mt_40 pb_100`}>
					<p>가입상품 목록 전송요구 및 개인(신용) 정보 수집 ・ 이용 동의서(목록정보전송)</p>
					<span className="mt_10">
						핀테크는 ⌜신용정보의 이용 및 보호에 관한 법률⌟, ⌜개인정보 보호법⌟등 관련 법령에 따라 다음과 같이 귀하의 개인(신용)정보를 처리합니다.
					</span>
					<ul className="mt_40">
						<li>
							<div>거부 권리 및 불이익</div>
							<span>
								귀하는 개인(신용)정보 수집 ・ 이용에 관한 동의를 거부 하실 수 있습니다. 다만, “수집 ・ 이용에 관한 동의”는 본인신용 정보 통합조회, 데이터분석 서비스의 이용을 위한 필수적 사항이므로 동의를 거부할 경우 본인신용정보 통합조회, 데이터분석 서비스의 이용이 제한될 수 있습니다.
							</span>
						</li>
						<li>
							<div>정보제공자</div>
							<span>
								{
									selectedOrgs &&
									selectedOrgs.map((item, index) => {
										return <span className="ml_5" key={index}>{item.insttNm}{index < selectedOrgs.length - 1 && ", "}</span>
									})
								}
							</span>
						</li>
						<li>
							<div>개인(신용)정보를 제공받는자</div>
							<span>{App.comName}</span>
						</li>
						<li>
							<div>전송요구 및 수집 ・ 이용 목적</div>
							<span>상세정보 전송요구를 위한 가입상품 목록 조회</span>
						</li>
						<li>
							<div>전송요구 종료시점, 보유 및 이용기간</div>
							<p className="text-blue mt_10">상세정보 전송요구 시까지 또는 7일 중 짧은 기간</p>
						</li>
						<li>
							<div>전송을 요구하는 개인(신용)정보(수집 ・ 이용 항목)</div>
							<div className={styles.category}>
								<div>
									<p>개인(식별)정보</p>
									<span>・ 전자서명, 접근토큰, 인증서, 전송요구서</span>
								</div>
							</div>
							<div className={styles.category}>
								<div>
									<p>개인(신용)거래정보</p>
									<div className="pl_10">
										{
											industries &&
											industries.map((item, index) => {
												return (
													<div key={index} className={index > 0 ? "mt_5" : undefined}>
														<div className='bold'>{transmitRequestInfo[item].name}</div>
														<span style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>{transmitRequestInfo[item].data}</span>
													</div>
												)
											})
										}
									</div>
								</div>
							</div>
						</li>
					</ul>
					<p className="mt_30">위와 같은 전송요구 및 개인(신용)정보 수집 ・ 이용에 동의하십니까?</p>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				<div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div>
				<Button className="btn btn--big" onClick={onNext}>{buttonText}</Button>
			</div>
		</div>
	)
}

export default TransmitRequest1